module.exports = __webpack_public_path__ + "static/media/buy_request_details_help_5-2.2a29bb54.png";